import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import { setZonaPengguna } from "../utils/waktuCabang";
import axios from 'axios';
import { catatLogout } from '../utils/tungguLogout';
import { apiHost } from '../utils/apiHost';
import { idPerangkat } from '../utils/perangkat';

const getApiBaseUrl = () => {
    const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
    const baseUrl = apiHost().replace(/^https?:\/\//, '');
    return `${protocol}://${baseUrl}`;
};

const initialState = {  
   // user: null,
   user: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    isAuthenticated: false,
    isInitialized: false,
}

export const Login = createAsyncThunk("user/login", async (user, thunkAPI) => {
    try {
        const response = await axios.post(`${getApiBaseUrl()}/login`,
            new URLSearchParams({
                username: user.username,
                password: user.password
            }), {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
     //   console.log("Login response:", response.data);
        return response.data;
    } catch (error) {
        if (error.response) {
            const message = error.response.data.message;
            console.log("Error response:", error.response.data);
            return thunkAPI.rejectWithValue(message);
        }
    }
});

export const Me = createAsyncThunk("user/me", async(__, thunkAPI) => {
    try {
        const response = await axios.get(`${getApiBaseUrl()}/me`,
    {withCredentials: true}
    );console.log('Response /me:', response.data);
    return response.data;
    } catch (error) {
        if (error.response) {
            const message = error.response.data.msg;
            return thunkAPI.rejectWithValue(message);
        };
    }
});

export const Logout = createAsyncThunk("user/logout", async() => {
// Penanda perangkat: server hanya menutup sesi layar pelanggan browser ini (perangkat lain akun yang sama tidak terganggu).
const permintaan = axios.delete(`${getApiBaseUrl()}/logout`, { headers: { 'X-Perangkat-Id': idPerangkat() } });
catatLogout(permintaan); // pengalihan ke domain utama menunggu ini selesai (utils/tungguLogout.js)
await permintaan;
 });

 export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(Login.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
            state.message = "";
        });
        builder.addCase(Login.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.user = action.payload?.data || action.payload;
            setZonaPengguna(state.user?.cabang?.zona_waktu || state.user?.Cabang?.zona_waktu);
            state.isAuthenticated = true;
            state.isInitialized = true;
            state.isError = false;
            state.message = "";
        });
        builder.addCase(Login.rejected, (state, action) => {
          //  console.log("Rejected action payload:", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
            state.isAuthenticated = false;
            state.user = null;
            state.isInitialized = true;
        });

        builder.addCase(Me.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(Me.fulfilled, (state, action) => {
           // console.log('Data pengguna dari API /me:', action.payload);
            state.isLoading = false;
            state.isSuccess = true;
            state.user = action.payload;
            setZonaPengguna(action.payload?.cabang?.zona_waktu || action.payload?.Cabang?.zona_waktu);
            state.isAuthenticated = true;
            state.isInitialized = true;
            state.isError = false;
            state.message = "";
        });
        builder.addCase(Me.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.isAuthenticated = false;
            state.user = null;
            state.message = action.payload;
            state.isInitialized = true;
        });

        builder.addCase(Logout.fulfilled, (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.isInitialized = true;
            state.isSuccess = false;
            state.isError = false;
            state.message = "";
        });
    },
});


export const{ reset } = authSlice.actions;
export default authSlice.reducer;

